module.exports = __webpack_public_path__ + "static/img/C4D0027.ba0ae4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/intru/C4D0027.jpg
// module id = bnsi
// module chunks = 0